export const NEW_ACCOUNT_ERRORS = {
  FORMAT_EMAIL: "Email inválido.",
  INVALID: "El email parece estar registrado. Por favor, intente nuevamente.",
  GENERIC: "Hubo un error, intente nuevamente.",
};
